export const TITLE = 'Solink Video Discovery';

export const SETTINGS_PAGE_URL = {
  USERS: 'users',
  USER_ROLES: 'userroles',
  NOTIFICATIONS: 'notifications',
  ACCOUNT: 'account',
  PREFERENCES: 'preferences',
  LANGUAGES: 'languages',
  RECORDINGS: 'recordings',
  OVERRIDES: 'overrides',
  APPS: 'apps',
  REFERRAL: 'referral',
  LEGACY_REPORTS: 'reports',
  LOCATION_MANAGEMENT: 'location-management',
  LOCATION_DETAILS: 'locations',
  CLOUD_STORAGE: 'cloud-storage',
  CLOUD_VIDEO_BACKUP: 'cloud-video-backup',
  EVENT_FLOW: 'event-flow',
  AGENTS: 'agents',
  DEVELOPER: 'developer',
};

export const TIME_FORMAT = {
  TWELVE_HOUR: 'twelvehour',
  TWENTY_FOUR_HOUR: 'twentyfourhour',
} as const;

export const STANDARD_12H_DATE_TIME_FORMAT = 'YYYY-MM-DD hh:mm:ss A';
